import { useEffect, useState } from 'react';
import apiService from '../../axios/apiService';
import { useLocation } from 'react-router-dom';
import { getSearchParamFromLocation } from '../../utils/mapper';
import { ApplicationRoutes } from '../../authguard/routes';

export const useGetCase = () => {
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const getCase = async () => {
    // Fetch case
    setLoading(true);
    try {
      const id = getSearchParamFromLocation('id', location);
      if (!id) return;
      const response = await apiService.getCase(id);
      response && setData(response); // update data state
      return response;
    } catch (error) {
      console.log('Error: ', error);
    } finally {
      setLoading(false);
    }
  };

  // Initial component mount
  useEffect(() => {
    if (
      location?.pathname === ApplicationRoutes.CaseEdit ||
      location?.pathname === ApplicationRoutes.CaseView
    ) {
      getCase();
    }
  }, [location?.search]);

  return {
    data,
    loading,
    getCase,
  };
};
